import type { FC } from "react";
import { DetailCardSkeleton } from "web_myplann/Portfolio/Components/Redesign/Detail/Skeletons/DetailCardSkeleton";
import { DetailValueChartSkeleton } from "web_myplann/Portfolio/Components/Redesign/Detail/Skeletons/DetailValueChartSkeleton";

type Props = {
	hasChart?: boolean;
};

export const DetailSkeleton: FC<Props> = ({ hasChart = false }) => (
	<>
		{hasChart && <DetailValueChartSkeleton />}
		<DetailCardSkeleton rows={5} />
		<DetailCardSkeleton rows={3} />
	</>
);
